<template>
    <div
      style="margin-bottom: 20px"
      class="col-md-12 col-sm-12"
      v-for="user in users"
      :key="user.id"
    >
      <div class="card">
        <div class="card-body">
          <div class="row" style="margin-bottom: 30px">
            <div class="col-md-3">
              ID : {{ user.id }} <br />
              Email: {{ user.email }} <br />
              First Name: {{ user.firstname }} <br />
              Last Name: {{ user.lastname }} <br />
              Phone: {{ user.phone }} <br />
              Birth Year: {{ user.birthYear }} <br />
              Gender: {{ user.sex }} <br />
              Country: {{ user.country }} <br />
              Timezone: {{ user.timezone }} <br />
              Klaviyo: <a :href="`https://www.klaviyo.com/profile/${user.klaviyoProfileId}`" target="_blank">{{
              user.klaviyoProfileId
            }}</a><br />
            </div>
            <div class="col-md-3">
              Locked : <input class="form-check-input" type="checkbox" :checked="user.isLocked" disabled /> <br />
              Failed Login Attempts: {{ user.failedLogInAttempts }} <br />
              Locked At: {{ user.lockedAt }} <br />
              Status: {{ user.status }} <br />
              Created At: {{ user.createdAt }} <br />
              Updated At: {{ user.updatedAt }} <br />
              Deleted: <input class="form-check-input" type="checkbox" :checked="user._isDeleted" disabled /> <br />
              Deleted At: {{ user.deletedAt }} <br />
            </div>

            <div class="col-md-3">
              Currency Unit: {{ user.currencyUnit }} <br />
              Distance Unit: {{ user.distanceUnit }} <br />
              Economy Unit: {{user.economyUnit}} <br />
              Fuel Unit: {{ user.fuelUnit }} <br />
              Weight Unit: {{ user.weightUnit }} <br />
            </div>
            <div class="col-md-3">
              Business Tags Enabled: <input class="form-check-input" type="checkbox" :checked="user.businessTagEnabled" disabled /> <br />
              Has Client Tags: <input class="form-check-input" type="checkbox" :checked="user.isClientTagAvailable" disabled /> <br />
              Has Purpose Tags: <input class="form-check-input" type="checkbox" :checked="user.isPurposeTagAvailable" disabled /> <br />
              Tagging Sound Effect Enabled: <input class="form-check-input" type="checkbox" :checked="user.isTaggingSoundEffectEnabled" disabled /> <br />
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  name: 'UsersGrid',
  props: {
    users: []
  }  
}
</script>
